import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {useMeterAssignment} from "../hooks/useMeterAssignment.ts";
import {AssignmentStatus, MeterAssignment} from "../types.ts";

export const AddFormDrawer = (props: DrawerProps) => {
    const {
        createRecord,
    } = useMeterAssignment();

    return (
        <FormDrawer
            record={{
                id: '',
                customerId: '',
                meterId: '',
                // FNP-616: empty default — the user picks from the catalog-driven channel
                // options (no hardcoded provider).
                channel: '',
                channelIdentifiers: {},
                status: AssignmentStatus.ACTIVE,
                effectiveFrom: '',
            } as MeterAssignment}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
